export default "__VITE_ASSET__tRRfdyPN__"